import { render, staticRenderFns } from "./AuthenticateTransferComponent.vue?vue&type=template&id=13706a0a&scoped=true&"
import script from "./AuthenticateTransferComponent.vue?vue&type=script&lang=js&"
export * from "./AuthenticateTransferComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticateTransferComponent.vue?vue&type=style&index=0&id=13706a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13706a0a",
  null
  
)

export default component.exports